
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n611Child = []
  var n612Child = []
  var n613Child = []
  var n614Child = []
  var props = {attributes: runtime.compileAttrs([{name:'afterCreate', val: this.updatePreviewFrame},{name:'afterUpdate', val: this.updatePreviewFrame}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n614 = h('iframe', props, n614Child)
  n613Child.push(n614)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'preview-container'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n613 = h('div', props, n613Child)
  n612Child.push(n613)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'column'},{name:'class', val: 'is-narrow'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n612 = h('div', props, n612Child)
  n611Child.push(n612)
  var n615Child = []
  var n616Child = []
  var n617Child = []
  var n618Child = []
  n618Child = n618Child.concat(text(t('.mode')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'},{name:'class', val: 'nowrap'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n618 = h('label', props, n618Child)
  n617Child.push(n618)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n617 = h('div', props, n617Child)
  n616Child.push(n617)
  var n619Child = []
  var n620Child = []
  var n621Child = []
  var n622Child = []
  var n623Child = []
  var n624Child = []
  n624Child = n624Child.concat(text(t('.mode_webview')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "webview"},{name:'selected', val: shadow.type == "webview"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n624 = h('option', props, n624Child)
  n623Child.push(n624)
  var n625Child = []
  n625Child = n625Child.concat(text(t('.mode_map')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "map"},{name:'selected', val: shadow.type == "map"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n625 = h('option', props, n625Child)
  n623Child.push(n625)
  var n626Child = []
  n626Child = n626Child.concat(text(t('.mode_video')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "video"},{name:'selected', val: shadow.type == "video"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n626 = h('option', props, n626Child)
  n623Child.push(n626)
  var props = {attributes: runtime.compileAttrs([{name:'name', val: "type"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n623 = h('select', props, n623Child)
  n622Child.push(n623)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'select'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n622 = h('div', props, n622Child)
  n621Child.push(n622)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n621 = h('div', props, n621Child)
  n620Child.push(n621)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n620 = h('div', props, n620Child)
  n619Child.push(n620)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n619 = h('div', props, n619Child)
  n616Child.push(n619)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "type"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n616 = h('div', props, n616Child)
  n615Child.push(n616)
  if(shadow.type == "webview") {
    var n627Child = []
    var n628Child = []
    var n629Child = []
    n629Child = n629Child.concat(text(t('.template')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'},{name:'class', val: 'nowrap'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n629 = h('label', props, n629Child)
    n628Child.push(n629)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n628 = h('div', props, n628Child)
    n627Child.push(n628)
    var n630Child = []
    var n631Child = []
    var n632Child = []
    var n633Child = []
    var n634Child = []
    var n635Child = []
    n635Child = n635Child.concat(text(t('.template_custom')))
    var props = {attributes: runtime.compileAttrs([{name:'value', val: "custom"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n635 = h('option', props, n635Child)
    n634Child.push(n635)
    var v636 = this.HTML_TEMPLATES
    Object.keys(v636).forEach(function (key) {
      var template = v636[key]
      var n637Child = []
      n637Child = n637Child.concat(text(template.name))
      var props = {attributes: runtime.compileAttrs([{name:'value', val: key}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n637 = h('option', props, n637Child)
      n634Child.push(n637)
    }.bind(this))
    var props = {attributes: runtime.compileAttrs([{name:'name', val: "_template"},{name:'value', val: (shadow._template || "custom")}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n634 = h('select', props, n634Child)
    n633Child.push(n634)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'select'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n633 = h('div', props, n633Child)
    n632Child.push(n633)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n632 = h('div', props, n632Child)
    n631Child.push(n632)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n631 = h('div', props, n631Child)
    n630Child.push(n631)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n630 = h('div', props, n630Child)
    n627Child.push(n630)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "template"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n627 = h('div', props, n627Child)
    n615Child.push(n627)
  }
  switch(shadow.type) {
    case "webview":
      if(this.template) {
        var v638 = this.template.form
        Object.keys(v638).forEach(function (key) {
          var label = v638[key]
          var n639Child = []
          var n640Child = []
          var n641Child = []
          n641Child = n641Child.concat(text(label))
          var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'},{name:'class', val: 'nowrap'}], [])};
          if (props.attributes.id) props.key = props.attributes.id;
          var n641 = h('label', props, n641Child)
          n640Child.push(n641)
          var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
          if (props.attributes.id) props.key = props.attributes.id;
          var n640 = h('div', props, n640Child)
          n639Child.push(n640)
          var n642Child = []
          var n643Child = []
          var n644Child = []
          var n645Child = []
          if(domIdField = this.template.domIdFields[key]) {
            switch(domIdField.type) {
              case "button":
                var n646Child = []
                n646Child = n646Child.concat(text(t('.set_click')))
                var props = {attributes: runtime.compileAttrs([{name:'type', val: "button"},{name:'onclick', val: this.editClickCondition.bind(this, key)}], [])};
                if (props.attributes.id) props.key = props.attributes.id;
                var n646 = h('button', props, n646Child)
                n645Child.push(n646)
                break;
              case "input":
                var n647Child = []
                n647Child = n647Child.concat(text(t('.add_input_response')))
                var props = {attributes: runtime.compileAttrs([{name:'type', val: "button"},{name:'onclick', val: this.addInputResponse.bind(this, key)}], [])};
                if (props.attributes.id) props.key = props.attributes.id;
                var n647 = h('button', props, n647Child)
                n645Child.push(n647)
                break;
            }
          }
          var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'type', val: "text"},{name:'name', val: `_templateData[${key}]`},{name:'value', val: this.templateData(key)}], [])};
          if (props.attributes.id) props.key = props.attributes.id;
          var n645 = h('input', props, n645Child)
          n644Child.push(n645)
          var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
          if (props.attributes.id) props.key = props.attributes.id;
          var n644 = h('div', props, n644Child)
          n643Child.push(n644)
          var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
          if (props.attributes.id) props.key = props.attributes.id;
          var n643 = h('div', props, n643Child)
          n642Child.push(n643)
          var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
          if (props.attributes.id) props.key = props.attributes.id;
          var n642 = h('div', props, n642Child)
          n639Child.push(n642)
          var props = {attributes: runtime.compileAttrs([{name:'class', val: 'is-horizontal'},{name:'key', val: key}], [])};
          if (props.attributes.id) props.key = props.attributes.id;
          var n639 = h('field', props, n639Child)
          n615Child.push(n639)
        }.bind(this))
      } else {
        var n648Child = []
        var n649Child = []
        n649Child.push(text("HTML"))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n649 = h('label', props, n649Child)
        n648Child.push(n649)
        var n650Child = []
        var n651Child = []
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'textarea'},{name:'name', val: "displayHtml"},{name:'value', val: shadow.displayHtml}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n651 = h('textarea', props, n651Child)
        n650Child.push(n651)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n650 = h('div', props, n650Child)
        n648Child.push(n650)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'key', val: "displayHtml"}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n648 = h('div', props, n648Child)
        n615Child.push(n648)
      }
      break;
    case "map":
      var n652Child = []
      var n653Child = []
      var n654Child = []
      n654Child = n654Child.concat(text(t('.current_location_icon')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n654 = h('label', props, n654Child)
      n653Child.push(n654)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n653 = h('div', props, n653Child)
      n652Child.push(n653)
      var n655Child = []
      var n656Child = []
      var n657Child = []
      var n658Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "currentLocationMarker[assetId]"},{name:'value', val: shadow.currentLocationMarker.assetId}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n658 = h('input', props, n658Child)
      n657Child.push(n658)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n657 = h('div', props, n657Child)
      n656Child.push(n657)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n656 = h('div', props, n656Child)
      n655Child.push(n656)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n655 = h('div', props, n655Child)
      n652Child.push(n655)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "currentLocationMarker[assetId]"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n652 = h('div', props, n652Child)
      n615Child.push(n652)
      var n659Child = []
      var n660Child = []
      var n661Child = []
      n661Child = n661Child.concat(text(t('.current_location_icon_size')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n661 = h('label', props, n661Child)
      n660Child.push(n661)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n660 = h('div', props, n660Child)
      n659Child.push(n660)
      var n662Child = []
      var n663Child = []
      var n664Child = []
      var n665Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "currentLocationMarker[size]"},{name:'type', val: "number"},{name:'value', val: shadow.currentLocationMarker.size}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n665 = h('input', props, n665Child)
      n664Child.push(n665)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n664 = h('div', props, n664Child)
      n663Child.push(n664)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n663 = h('div', props, n663Child)
      n662Child.push(n663)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n662 = h('div', props, n662Child)
      n659Child.push(n662)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "currentLocationMarker[size]"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n659 = h('div', props, n659Child)
      n615Child.push(n659)
      var n666Child = []
      var n667Child = []
      n667Child = n667Child.concat(text(t('.landmark')))
      var props = {attributes: runtime.compileAttrs([], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n667 = h('b', props, n667Child)
      n666Child.push(n667)
      var n668Child = []
      var n669Child = []
      var n670Child = []
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: 'fa-plus'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n670 = h('i', props, n670Child)
      n669Child.push(n670)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n669 = h('span', props, n669Child)
      n668Child.push(n669)
      var n671Child = []
      n671Child = n671Child.concat(text(t('.add')))
      var props = {attributes: runtime.compileAttrs([], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n671 = h('span', props, n671Child)
      n668Child.push(n671)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-primary'},{name:'onclick', val: this.addPositionMarker},{name:'type', val: "button"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n668 = h('button', props, n668Child)
      n666Child.push(n668)
      var v672 = shadow.positionMarkers
      Object.keys(v672).forEach(function (index) {
        var positionMarker = v672[index]
        var n673Child = []
        var n674Child = []
        n674Child = n674Child.concat(text(t('.delete')))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-small'},{name:'class', val: 'is-danger'},{name:'type', val: "button"},{name:'onclick', val: this.deletePositionMarker.bind(this, positionMarker)}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n674 = h('button', props, n674Child)
        n673Child.push(n674)
        var n675Child = []
        var n676Child = []
        var n677Child = []
        n677Child = n677Child.concat(text(t('.longitude')))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n677 = h('label', props, n677Child)
        n676Child.push(n677)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n676 = h('div', props, n676Child)
        n675Child.push(n676)
        var n678Child = []
        var n679Child = []
        var n680Child = []
        var n681Child = []
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `positionMarkers[${index}][longitude]`},{name:'value', val: positionMarker.longitude},{name:'type', val: "number"},{name:'step', val: "0.000000001"}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n681 = h('input', props, n681Child)
        n680Child.push(n681)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n680 = h('div', props, n680Child)
        n679Child.push(n680)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n679 = h('div', props, n679Child)
        n678Child.push(n679)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n678 = h('div', props, n678Child)
        n675Child.push(n678)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n675 = h('div', props, n675Child)
        n673Child.push(n675)
        var n682Child = []
        var n683Child = []
        var n684Child = []
        n684Child = n684Child.concat(text(t('.latitude')))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n684 = h('label', props, n684Child)
        n683Child.push(n684)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n683 = h('div', props, n683Child)
        n682Child.push(n683)
        var n685Child = []
        var n686Child = []
        var n687Child = []
        var n688Child = []
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: `positionMarkers[${index}][latitude]`},{name:'value', val: positionMarker.latitude},{name:'type', val: "number"},{name:'step', val: "0.000000001"}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n688 = h('input', props, n688Child)
        n687Child.push(n688)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n687 = h('div', props, n687Child)
        n686Child.push(n687)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n686 = h('div', props, n686Child)
        n685Child.push(n686)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n685 = h('div', props, n685Child)
        n682Child.push(n685)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n682 = h('div', props, n682Child)
        n673Child.push(n682)
        var n689Child = []
        var n690Child = []
        var n691Child = []
        n691Child = n691Child.concat(text(t('.asset_id')))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n691 = h('label', props, n691Child)
        n690Child.push(n691)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n690 = h('div', props, n690Child)
        n689Child.push(n690)
        var n692Child = []
        var n693Child = []
        var n694Child = []
        var n695Child = []
        var props = {attributes: runtime.compileAttrs([{name:'name', val: `positionMarkers[${index}][assetId]`},{name:'value', val: positionMarker.assetId}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n695 = h('input', props, n695Child)
        n694Child.push(n695)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n694 = h('div', props, n694Child)
        n693Child.push(n694)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n693 = h('div', props, n693Child)
        n692Child.push(n693)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n692 = h('div', props, n692Child)
        n689Child.push(n692)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n689 = h('div', props, n689Child)
        n673Child.push(n689)
        var n696Child = []
        var n697Child = []
        var n698Child = []
        n698Child = n698Child.concat(text(t('.size')))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n698 = h('label', props, n698Child)
        n697Child.push(n698)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n697 = h('div', props, n697Child)
        n696Child.push(n697)
        var n699Child = []
        var n700Child = []
        var n701Child = []
        var n702Child = []
        var props = {attributes: runtime.compileAttrs([{name:'name', val: `positionMarkers[${index}][size]`},{name:'type', val: "number"},{name:'value', val: positionMarker.size}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n702 = h('input', props, n702Child)
        n701Child.push(n702)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n701 = h('div', props, n701Child)
        n700Child.push(n701)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n700 = h('div', props, n700Child)
        n699Child.push(n700)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n699 = h('div', props, n699Child)
        n696Child.push(n699)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n696 = h('div', props, n696Child)
        n673Child.push(n696)
        var n703Child = []
        var n704Child = []
        var n705Child = []
        n705Child = n705Child.concat(text(t('.z_index')))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n705 = h('label', props, n705Child)
        n704Child.push(n705)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n704 = h('div', props, n704Child)
        n703Child.push(n704)
        var n706Child = []
        var n707Child = []
        var n708Child = []
        var n709Child = []
        var props = {attributes: runtime.compileAttrs([{name:'name', val: `positionMarkers[${index}][zIndex]`},{name:'type', val: "number"},{name:'value', val: positionMarker.zIndex}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n709 = h('input', props, n709Child)
        n708Child.push(n709)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n708 = h('div', props, n708Child)
        n707Child.push(n708)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n707 = h('div', props, n707Child)
        n706Child.push(n707)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n706 = h('div', props, n706Child)
        n703Child.push(n706)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n703 = h('div', props, n703Child)
        n673Child.push(n703)
        var n710Child = []
        var props = {attributes: runtime.compileAttrs([], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n710 = h('hr', props, n710Child)
        n673Child.push(n710)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'position-marker'},{name:'key', val: positionMarker}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n673 = h('div', props, n673Child)
        n666Child.push(n673)
      }.bind(this))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'position-markers'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n666 = h('div', props, n666Child)
      n615Child.push(n666)
      var n711Child = []
      var n712Child = []
      var n713Child = []
      n713Child = n713Child.concat(text(t('.style')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n713 = h('label', props, n713Child)
      n712Child.push(n713)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n712 = h('div', props, n712Child)
      n711Child.push(n712)
      var n714Child = []
      var n715Child = []
      var n716Child = []
      var n717Child = []
      n717Child = n717Child.concat(text(shadow.styleJSON))
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "styleJSON"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n717 = h('textarea', props, n717Child)
      n716Child.push(n717)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n716 = h('div', props, n716Child)
      n715Child.push(n716)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n715 = h('div', props, n715Child)
      n714Child.push(n715)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n714 = h('div', props, n714Child)
      n711Child.push(n714)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "styleJSON"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n711 = h('div', props, n711Child)
      n615Child.push(n711)
      break;
    case "video":
      if(!(shadow.youtubeVideoId)) {
        var n718Child = []
        var n719Child = []
        var n720Child = []
        n720Child = n720Child.concat(text(t('.resource_id')))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n720 = h('label', props, n720Child)
        n719Child.push(n720)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n719 = h('div', props, n719Child)
        n718Child.push(n719)
        var n721Child = []
        var n722Child = []
        var n723Child = []
        var n724Child = []
        var props = {attributes: runtime.compileAttrs([{name:'name', val: "assetId"},{name:'type', val: "text"},{name:'value', val: shadow.assetId}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n724 = h('input', props, n724Child)
        n723Child.push(n724)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n723 = h('div', props, n723Child)
        n722Child.push(n723)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n722 = h('div', props, n722Child)
        n721Child.push(n722)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n721 = h('div', props, n721Child)
        n718Child.push(n721)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "assetId"}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n718 = h('div', props, n718Child)
        n615Child.push(n718)
      }
      if(!(shadow.assetId)) {
        var n725Child = []
        var n726Child = []
        var n727Child = []
        n727Child = n727Child.concat(text(t('.youtube_id')))
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n727 = h('label', props, n727Child)
        n726Child.push(n727)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n726 = h('div', props, n726Child)
        n725Child.push(n726)
        var n728Child = []
        var n729Child = []
        var n730Child = []
        var n731Child = []
        var props = {attributes: runtime.compileAttrs([{name:'name', val: "youtubeVideoId"},{name:'type', val: "text"},{name:'value', val: shadow.youtubeVideoId}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n731 = h('input', props, n731Child)
        n730Child.push(n731)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n730 = h('div', props, n730Child)
        n729Child.push(n730)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n729 = h('div', props, n729Child)
        n728Child.push(n729)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n728 = h('div', props, n728Child)
        n725Child.push(n728)
        var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "youtubeVideoId"}], [])};
        if (props.attributes.id) props.key = props.attributes.id;
        var n725 = h('div', props, n725Child)
        n615Child.push(n725)
      }
      var n732Child = []
      var n733Child = []
      var n734Child = []
      n734Child = n734Child.concat(text(t('.vr_video')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n734 = h('label', props, n734Child)
      n733Child.push(n734)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n733 = h('div', props, n733Child)
      n732Child.push(n733)
      var n735Child = []
      var n736Child = []
      var n737Child = []
      var n738Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "is360"},{name:'type', val: "checkbox"},{name:'value', val: "true"},{name:'checked', val: shadow.is360}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n738 = h('input', props, n738Child)
      n737Child.push(n738)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n737 = h('div', props, n737Child)
      n736Child.push(n737)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n736 = h('div', props, n736Child)
      n735Child.push(n736)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n735 = h('div', props, n735Child)
      n732Child.push(n735)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "is360"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n732 = h('div', props, n732Child)
      n615Child.push(n732)
      var n739Child = []
      var n740Child = []
      var n741Child = []
      n741Child = n741Child.concat(text(t('.fullscreen')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n741 = h('label', props, n741Child)
      n740Child.push(n741)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n740 = h('div', props, n740Child)
      n739Child.push(n740)
      var n742Child = []
      var n743Child = []
      var n744Child = []
      var n745Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "fullScreen"},{name:'type', val: "checkbox"},{name:'value', val: "true"},{name:'checked', val: shadow.fullScreen}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n745 = h('input', props, n745Child)
      n744Child.push(n745)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n744 = h('div', props, n744Child)
      n743Child.push(n744)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n743 = h('div', props, n743Child)
      n742Child.push(n743)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n742 = h('div', props, n742Child)
      n739Child.push(n742)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "fullScreen"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n739 = h('div', props, n739Child)
      n615Child.push(n739)
      var n746Child = []
      var n747Child = []
      var n748Child = []
      n748Child = n748Child.concat(text(t('.landscape')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n748 = h('label', props, n748Child)
      n747Child.push(n748)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n747 = h('div', props, n747Child)
      n746Child.push(n747)
      var n749Child = []
      var n750Child = []
      var n751Child = []
      var n752Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "rotate"},{name:'type', val: "checkbox"},{name:'value', val: "true"},{name:'checked', val: shadow.rotate}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n752 = h('input', props, n752Child)
      n751Child.push(n752)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n751 = h('div', props, n751Child)
      n750Child.push(n751)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n750 = h('div', props, n750Child)
      n749Child.push(n750)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n749 = h('div', props, n749Child)
      n746Child.push(n749)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "rotate"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n746 = h('div', props, n746Child)
      n615Child.push(n746)
      var n753Child = []
      var n754Child = []
      var n755Child = []
      n755Child = n755Child.concat(text(t('.autoplay')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n755 = h('label', props, n755Child)
      n754Child.push(n755)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n754 = h('div', props, n754Child)
      n753Child.push(n754)
      var n756Child = []
      var n757Child = []
      var n758Child = []
      var n759Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "autoPlay"},{name:'type', val: "checkbox"},{name:'value', val: "true"},{name:'checked', val: shadow.autoPlay}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n759 = h('input', props, n759Child)
      n758Child.push(n759)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n758 = h('div', props, n758Child)
      n757Child.push(n758)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n757 = h('div', props, n757Child)
      n756Child.push(n757)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n756 = h('div', props, n756Child)
      n753Child.push(n756)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "autoPlay"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n753 = h('div', props, n753Child)
      n615Child.push(n753)
      var n760Child = []
      var n761Child = []
      var n762Child = []
      n762Child = n762Child.concat(text(t('.show_progress')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n762 = h('label', props, n762Child)
      n761Child.push(n762)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n761 = h('div', props, n761Child)
      n760Child.push(n761)
      var n763Child = []
      var n764Child = []
      var n765Child = []
      var n766Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "showSeekBar"},{name:'type', val: "checkbox"},{name:'value', val: "true"},{name:'checked', val: shadow.showSeekBar}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n766 = h('input', props, n766Child)
      n765Child.push(n766)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n765 = h('div', props, n765Child)
      n764Child.push(n765)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n764 = h('div', props, n764Child)
      n763Child.push(n764)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n763 = h('div', props, n763Child)
      n760Child.push(n763)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "showSeekBar"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n760 = h('div', props, n760Child)
      n615Child.push(n760)
      var n767Child = []
      var n768Child = []
      var n769Child = []
      n769Child = n769Child.concat(text(t('.show_play_pause')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n769 = h('label', props, n769Child)
      n768Child.push(n769)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n768 = h('div', props, n768Child)
      n767Child.push(n768)
      var n770Child = []
      var n771Child = []
      var n772Child = []
      var n773Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "showPlayPauseButton"},{name:'type', val: "checkbox"},{name:'value', val: "true"},{name:'checked', val: shadow.showPlayPauseButton}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n773 = h('input', props, n773Child)
      n772Child.push(n773)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n772 = h('div', props, n772Child)
      n771Child.push(n772)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n771 = h('div', props, n771Child)
      n770Child.push(n771)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n770 = h('div', props, n770Child)
      n767Child.push(n770)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "showPlayPauseButton"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n767 = h('div', props, n767Child)
      n615Child.push(n767)
      var n774Child = []
      var n775Child = []
      var n776Child = []
      n776Child = n776Child.concat(text(t('.show_volume')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n776 = h('label', props, n776Child)
      n775Child.push(n776)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n775 = h('div', props, n775Child)
      n774Child.push(n775)
      var n777Child = []
      var n778Child = []
      var n779Child = []
      var n780Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "showVolumeControl"},{name:'type', val: "checkbox"},{name:'value', val: "true"},{name:'checked', val: shadow.showVolumeControl}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n780 = h('input', props, n780Child)
      n779Child.push(n780)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n779 = h('div', props, n779Child)
      n778Child.push(n779)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n778 = h('div', props, n778Child)
      n777Child.push(n778)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n777 = h('div', props, n777Child)
      n774Child.push(n777)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "showVolumeControl"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n774 = h('div', props, n774Child)
      n615Child.push(n774)
      var n781Child = []
      var n782Child = []
      var n783Child = []
      n783Child = n783Child.concat(text(t('.pause')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n783 = h('label', props, n783Child)
      n782Child.push(n783)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n782 = h('div', props, n782Child)
      n781Child.push(n782)
      var n784Child = []
      var n785Child = []
      var n786Child = []
      var n787Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "pause"},{name:'type', val: "checkbox"},{name:'value', val: "true"},{name:'checked', val: shadow.pause}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n787 = h('input', props, n787Child)
      n786Child.push(n787)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n786 = h('div', props, n786Child)
      n785Child.push(n786)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n785 = h('div', props, n785Child)
      n784Child.push(n785)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n784 = h('div', props, n784Child)
      n781Child.push(n784)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "pause"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n781 = h('div', props, n781Child)
      n615Child.push(n781)
      var n788Child = []
      var n789Child = []
      var n790Child = []
      n790Child = n790Child.concat(text(t('.position')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n790 = h('label', props, n790Child)
      n789Child.push(n790)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n789 = h('div', props, n789Child)
      n788Child.push(n789)
      var n791Child = []
      var n792Child = []
      var n793Child = []
      var n794Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: "currentTime"},{name:'type', val: "number"},{name:'value', val: shadow.currentTime}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n794 = h('input', props, n794Child)
      n793Child.push(n794)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n793 = h('div', props, n793Child)
      n792Child.push(n793)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n792 = h('div', props, n792Child)
      n791Child.push(n792)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n791 = h('div', props, n791Child)
      n788Child.push(n791)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'},{name:'key', val: "currentTime"}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n788 = h('div', props, n788Child)
      n615Child.push(n788)
      break;
    default:
      var n795Child = []
      n795Child = n795Child.concat(text(t('.unsupported_type')))
      var props = {attributes: runtime.compileAttrs([], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n795 = h('p', props, n795Child)
      n615Child.push(n795)
      break;
  }
  if(shadow.type == "map" || shadow.type == "video") {
    var n796Child = []
    var n797Child = []
    n797Child = n797Child.concat(text(t('.image_overlays')))
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n797 = h('b', props, n797Child)
    n796Child.push(n797)
    var n798Child = []
    var n799Child = []
    var n800Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: 'fa-plus'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n800 = h('i', props, n800Child)
    n799Child.push(n800)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n799 = h('span', props, n799Child)
    n798Child.push(n799)
    var n801Child = []
    n801Child = n801Child.concat(text(t('.add')))
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n801 = h('span', props, n801Child)
    n798Child.push(n801)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-primary'},{name:'onclick', val: this.addImageOverlay},{name:'type', val: "button"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n798 = h('button', props, n798Child)
    n796Child.push(n798)
    var v802 = shadow.imageOverlays
    Object.keys(v802).forEach(function (index) {
      var imageOverlay = v802[index]
      var n803Child = []
      var n804Child = []
      n804Child = n804Child.concat(text(t('.delete')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-small'},{name:'class', val: 'is-danger'},{name:'type', val: "button"},{name:'onclick', val: this.deleteImageOverlay.bind(this, imageOverlay)}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n804 = h('button', props, n804Child)
      n803Child.push(n804)
      var n805Child = []
      var n806Child = []
      var n807Child = []
      n807Child = n807Child.concat(text(t('.overlay_id')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n807 = h('label', props, n807Child)
      n806Child.push(n807)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n806 = h('div', props, n806Child)
      n805Child.push(n806)
      var n808Child = []
      var n809Child = []
      var n810Child = []
      var n811Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: `imageOverlays[${index}][id]`},{name:'value', val: imageOverlay.id}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n811 = h('input', props, n811Child)
      n810Child.push(n811)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n810 = h('div', props, n810Child)
      n809Child.push(n810)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n809 = h('div', props, n809Child)
      n808Child.push(n809)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n808 = h('div', props, n808Child)
      n805Child.push(n808)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n805 = h('div', props, n805Child)
      n803Child.push(n805)
      var n812Child = []
      var n813Child = []
      var n814Child = []
      n814Child = n814Child.concat(text(t('.top')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n814 = h('label', props, n814Child)
      n813Child.push(n814)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n813 = h('div', props, n813Child)
      n812Child.push(n813)
      var n815Child = []
      var n816Child = []
      var n817Child = []
      var n818Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: `imageOverlays[${index}][top]`},{name:'type', val: "number"},{name:'value', val: imageOverlay.top}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n818 = h('input', props, n818Child)
      n817Child.push(n818)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n817 = h('div', props, n817Child)
      n816Child.push(n817)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n816 = h('div', props, n816Child)
      n815Child.push(n816)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n815 = h('div', props, n815Child)
      n812Child.push(n815)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n812 = h('div', props, n812Child)
      n803Child.push(n812)
      var n819Child = []
      var n820Child = []
      var n821Child = []
      n821Child = n821Child.concat(text(t('.bottom')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n821 = h('label', props, n821Child)
      n820Child.push(n821)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n820 = h('div', props, n820Child)
      n819Child.push(n820)
      var n822Child = []
      var n823Child = []
      var n824Child = []
      var n825Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: `imageOverlays[${index}][bottom]`},{name:'type', val: "number"},{name:'value', val: imageOverlay.bottom}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n825 = h('input', props, n825Child)
      n824Child.push(n825)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n824 = h('div', props, n824Child)
      n823Child.push(n824)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n823 = h('div', props, n823Child)
      n822Child.push(n823)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n822 = h('div', props, n822Child)
      n819Child.push(n822)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n819 = h('div', props, n819Child)
      n803Child.push(n819)
      var n826Child = []
      var n827Child = []
      var n828Child = []
      n828Child = n828Child.concat(text(t('.left')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n828 = h('label', props, n828Child)
      n827Child.push(n828)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n827 = h('div', props, n827Child)
      n826Child.push(n827)
      var n829Child = []
      var n830Child = []
      var n831Child = []
      var n832Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: `imageOverlays[${index}][left]`},{name:'type', val: "number"},{name:'value', val: imageOverlay.left}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n832 = h('input', props, n832Child)
      n831Child.push(n832)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n831 = h('div', props, n831Child)
      n830Child.push(n831)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n830 = h('div', props, n830Child)
      n829Child.push(n830)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n829 = h('div', props, n829Child)
      n826Child.push(n829)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n826 = h('div', props, n826Child)
      n803Child.push(n826)
      var n833Child = []
      var n834Child = []
      var n835Child = []
      n835Child = n835Child.concat(text(t('.right')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n835 = h('label', props, n835Child)
      n834Child.push(n835)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n834 = h('div', props, n834Child)
      n833Child.push(n834)
      var n836Child = []
      var n837Child = []
      var n838Child = []
      var n839Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: `imageOverlays[${index}][right]`},{name:'type', val: "number"},{name:'value', val: imageOverlay.right}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n839 = h('input', props, n839Child)
      n838Child.push(n839)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n838 = h('div', props, n838Child)
      n837Child.push(n838)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n837 = h('div', props, n837Child)
      n836Child.push(n837)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n836 = h('div', props, n836Child)
      n833Child.push(n836)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n833 = h('div', props, n833Child)
      n803Child.push(n833)
      var n840Child = []
      var n841Child = []
      var n842Child = []
      n842Child = n842Child.concat(text(t('.asset_id')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n842 = h('label', props, n842Child)
      n841Child.push(n842)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n841 = h('div', props, n841Child)
      n840Child.push(n841)
      var n843Child = []
      var n844Child = []
      var n845Child = []
      var n846Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: `imageOverlays[${index}][assetId]`},{name:'value', val: imageOverlay.assetId}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n846 = h('input', props, n846Child)
      n845Child.push(n846)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n845 = h('div', props, n845Child)
      n844Child.push(n845)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n844 = h('div', props, n844Child)
      n843Child.push(n844)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n843 = h('div', props, n843Child)
      n840Child.push(n843)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n840 = h('div', props, n840Child)
      n803Child.push(n840)
      var n847Child = []
      var n848Child = []
      var n849Child = []
      n849Child = n849Child.concat(text(t('.pressed_asset_id')))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n849 = h('label', props, n849Child)
      n848Child.push(n849)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'},{name:'class', val: 'is-normal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n848 = h('div', props, n848Child)
      n847Child.push(n848)
      var n850Child = []
      var n851Child = []
      var n852Child = []
      var n853Child = []
      var props = {attributes: runtime.compileAttrs([{name:'name', val: `imageOverlays[${index}][activeAssetId]`},{name:'value', val: imageOverlay.activeAssetId}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n853 = h('input', props, n853Child)
      n852Child.push(n853)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n852 = h('div', props, n852Child)
      n851Child.push(n852)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n851 = h('div', props, n851Child)
      n850Child.push(n851)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n850 = h('div', props, n850Child)
      n847Child.push(n850)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n847 = h('div', props, n847Child)
      n803Child.push(n847)
      var n854Child = []
      var props = {attributes: runtime.compileAttrs([], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n854 = h('hr', props, n854Child)
      n803Child.push(n854)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'image-overlay'},{name:'key', val: imageOverlay}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n803 = h('div', props, n803Child)
      n796Child.push(n803)
    }.bind(this))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'image-overlays'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n796 = h('div', props, n796Child)
    n615Child.push(n796)
  }
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'column'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n615 = h('div', props, n615Child)
  n611Child.push(n615)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'columns'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n611 = h('div', props, n611Child)
  n0Child.push(n611)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  